import { Body02 } from 'Components/designSystem';
import { TitleHuge } from 'Components/Titles';
import React from 'react';
import styled from 'styled-components';

import { ErrorTypes } from '../../api/error';
import { useErrorText } from '../../i18n/hooks';
import { ErrorProps } from './types';

const ErrorText = ({ tenant, error, isExpired }: ErrorProps) => {

    const et = useErrorText();

    const errorCode = typeof error === 'string' ? error : error?.errorCode;

    if (errorCode === ErrorTypes.Connection || errorCode === ErrorTypes.Timeout) {
        return (
            <StyledTitleHuge>{ et(errorCode) }</StyledTitleHuge>
        );
    }

    if (isExpired) {
        return <StyledExpiredMessage> { tenant?.candidateNoShiftsText ||
        'Thank you for your interest! This offer is not actual anymore' }</StyledExpiredMessage>;
    }

    return <BoldText>{ tenant?.periodCandidateInvalidTokenText }</BoldText>;
};

export default ErrorText;

const StyledTitleHuge = styled(TitleHuge)`
    text-align: center;

    @media(max-width: ${ ({ theme }) => theme.tabletBreakpoint }) {
        text-align: center;
        margin-bottom: ${ ({ theme }) => theme.size.size_10 };
    }
`;

const StyledExpiredMessage = styled(StyledTitleHuge)`
     margin-top: ${ ({ theme }) => theme.size.size_30 };
`;

const BoldText = styled(Body02)`
    font-family: ${ ({ theme }) => theme.type.boldFont };
    text-align: center;
`;
